import { type FetchMarketplaceAvailableMarketsPerPartnerData } from '@capsicum/common';

import { transformPartnerReferenceForTrending } from '../../partners/util/transformPartner';
import { useAvailableMarketsPerPartnerQuery } from '../data-access/queries/useAvailableMarketsPerPartnerQuery';

const availableMarketsPerPartnerTrendingReducer = ({ data }: FetchMarketplaceAvailableMarketsPerPartnerData) =>
	data?.map(transformPartnerReferenceForTrending)?.filter(partner => partner?.market?.isPercentagePositive);

export const useAvailableMarketsPerPartnerTrending = () => {
	return useAvailableMarketsPerPartnerQuery(availableMarketsPerPartnerTrendingReducer, {
		query: {
			direction: 'desc',
			limit: 5,
			orderBy: 'evolutionPercentage'
		}
	});
};
